<div appearance="fill" class="example-full-width" style="font-size: 16px !important;">
    <input class="form-control small-input" autocomplete="off" #txtSearchInp
        style="text-align: right; width: 100% !important;" [formControl]="query" placeholder="חיפוש חופשי..." name="txtSearchInp"
        id="txtSearchInp">
</div>